import { LocalStorageAccessor } from '../StorageAccessor/LocalStorageAccessor';

type PriceSpiderProductCodes = { [key: string]: number };

export class IsFromPriceSpiderAccessor {
    private static _key = 'priceSpiderProductCodes';
    private static _expiration = 24 * 60 * 60 * 1000;

    public static get(productCode: string): boolean {
        const priceSpiderProductCodes = LocalStorageAccessor.getObject<PriceSpiderProductCodes>(this._key, {});
        if (productCode in priceSpiderProductCodes && Date.now() - priceSpiderProductCodes[productCode] < this._expiration) {
            return true;
        }

        delete priceSpiderProductCodes[productCode];
        return false;
    }

    public static set(productCode: string): void {
        const priceSpiderProductCodes = LocalStorageAccessor.getObject<PriceSpiderProductCodes>(this._key, {});
        priceSpiderProductCodes[productCode] = Date.now();

        LocalStorageAccessor.setObject(this._key, priceSpiderProductCodes);
    }

    public static clear(...productCodes: string[]): void {
        let priceSpiderProductCodes = LocalStorageAccessor.getObject<PriceSpiderProductCodes>(this._key, {});
        if (productCodes.length) {
            productCodes.forEach((x) => delete priceSpiderProductCodes[x]);
        } else {
            priceSpiderProductCodes = {};
        }
        LocalStorageAccessor.setObject(this._key, priceSpiderProductCodes);
    }
}
